import React from 'react'
import OperacionesMuestras from '../OperacionesMuestras'

export const COLUMNS_MENU_DE_MUESTRAS = [
  {
    name: 'fechaDeRegistro',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nroMuestra',
    label: 'Nº Muestra',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'numero',
    label: 'CPE',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'usuario',
    label: 'Usuario',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'lote',
    label: 'Lote',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nroMuestra',
    label: 'Operación',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: value => {
        return <OperacionesMuestras numeroMuestra={value} />
      }
    }
  }
]
export const COLUMNS_MENU_DE_MUESTRAS_TO_PRINT = [
  {
    name: 'fechaDeRegistro',
    label: 'Fecha',
    width: 150,
    mantenerCase: true
  },
  {
    name: 'nroMuestra',
    label: 'Nº Muestra',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'numero',
    label: 'CPE',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'usuario',
    label: 'Usuario',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'lote',
    label: 'Lote',
    width: 60,
    mantenerCase: true
  }
]
